import { $translate } from '@/utils/i18n';
const DATA_TYPE_MAP = ['registry', 'parse'];// 数据类型对照（registry-注册，parse-解析）
const ECHART_TYPE_MAP = ['tendency-chart-line', 'tendency-chart-bar'];// 数据展示类型对照（tendency-chart-line-折线，tendency-chart-bar-柱状图）
const COLOR_LIST = ['#75a8ff', '#a69bff'];// 注册蓝色，解析紫色
const GRADUAL_COLOR_LIST = ['#cddefd', '#cac4ff'];// 折线渐变颜色
const AXIS_POINTER_IMG = [require('../../../../assets/images/registryPoint.svg'), require('../../../../assets/images/parsePoint.svg')];// 图片路径
const ECHARTS_TEMPLATE = [{// series模板
    type: 'line',
    showSymbol: false,
    symbolSize: 30
}, {
    type: 'bar',
    barWidth: '10px'
}];
const AXIS_POINTER_MAP = [{// axisPointer-对照
    type: 'line',
    lineStyle: {
        type: 'dashed'
    }
}, {
    type: 'shadow',
    shadowStyle: {
        color: '#000000',
        opacity: 0.1
    }
}];
const WAN = 10000;// 万
const MILLION = 10000000;// 千万
const HUNDRED_MILLION = 100000000;// 亿

// 通过数据展示类型、数据类型 -生成tooltip-axisPointer（坐标轴指示器配置项）
const getAxisPointer = (tendencyTypeIndex, dataTypeIndex) => {
    const currentTendency = AXIS_POINTER_MAP[tendencyTypeIndex];
    if (!tendencyTypeIndex) { // 当数据显示类型为折线时，设置对应颜色
        currentTendency.lineStyle.color = COLOR_LIST[dataTypeIndex];
    }
    return currentTendency;
};

// 通过数据展示类型、数据类型 -生成series基础配置
const getSeriseOption = (tendencyTypeIndex, dataTypeIndex, echarts) => {
    const currentSeriseOption = ECHARTS_TEMPLATE[tendencyTypeIndex];
    if (!tendencyTypeIndex) { // 当数据显示类型为折线时，设置对应areaStyle颜色
        currentSeriseOption.areaStyle = getGradualColor(dataTypeIndex, echarts);
    }
    return currentSeriseOption;
};

// 获取渐变颜色
const getGradualColor = (dataTypeIndex, echarts) => {
    return {
        color: new echarts.graphic.LinearGradient(
            0, 0, 0, 1,
            [
                {
                    offset: 0,
                    color: GRADUAL_COLOR_LIST[dataTypeIndex] // 0% 处的颜色
                },
                {
                    offset: 1,
                    color: '#fff' // 100% 处的颜色
                }
            ],
            false
        )
    };
};
/**
 * @desc 登陆后首页-echarts 配置
 * @param echartsData echarts数据
 * @param dataType 数据类型（registry-注册，parse-解析）
 * @param tendencyType 数据展示类型（tendency-chart-line-折线，tendency-chart-bar-柱状图）
 * @param echarts echarts实例
 */
export function getEchartsOptions(echartsData, dataType, tendencyType, echarts) {
    // XAxisData-X轴数据，max-Y轴最大值，interval-Y周间隔，seriesName-X轴name,seriesData-echarts展示数据，titleText-title
    const { XAxisData, max, interval, seriesName, seriesData, titleText } = echartsData;
    const tendencyTypeIndex = ECHART_TYPE_MAP.indexOf(tendencyType);// 当前数据展示类型，在echartTypeMap中的下标
    const dataTypeIndex = DATA_TYPE_MAP.indexOf(dataType);// 当前数据展示类型，在dataTypeMap中的下标
    return {
        title: {
            text: titleText,
            left: 'center',
            top: 8,
            textStyle: {
                color: '#666666',
                fontSize: 14,
                fontWeight: 500
            }
        },
        backgroundColor: '#ffffff',
        tooltip: {
            trigger: 'axis',
            padding: [6, 19, 6, 19],
            textStyle: {
                fontSize: 10
            },
            borderRadius: 0,
            axisPointer: {
                ...getAxisPointer(tendencyTypeIndex, dataTypeIndex)
            },
            formatter(params) {
                const { axisValue, seriesName: label, value } = params[0];
                return new Date().getMonth() + '-' + axisValue + '<br/>' + label + '：' + (value.toLocaleString());
            }

        },
        grid: {
            top: '15%',
            right: '3%',
            left: '7%',
            bottom: '12%'
        },
        xAxis: [
            {
                type: 'category',
                data: XAxisData,
                axisLine: {
                    lineStyle: {
                        color: '#D9D9D9',
                        type: 'solid',
                        fontSize: 14
                    }
                },
                axisLabel: {
                    margin: 10,
                    textStyle: {
                        fontSize: 12,
                        color: 'rgba(0,0,0,0.65)'
                    }
                },
                axisTick: {
                    alignWithLabel: true
                }
            }
        ],
        yAxis: [
            {
                axisLabel: {
                    color: '#000000',
                    formatter: (value, index) => {
                        if (value >= WAN && value < MILLION) {
                            value = (value / WAN).toString().substring(0, 6) + $translate('lang.E3202102250019', { defaultText: '万' });
                        } else if (value >= MILLION && value < HUNDRED_MILLION) {
                            value =
            (value / MILLION).toString().substring(0, 6) + $translate('lang.E3202102250020', { defaultText: '千万' });
                        } else if (value >= HUNDRED_MILLION) {
                            value = (value / HUNDRED_MILLION).toString().substring(0, 6) + $translate('lang.E3202102250021', { defaultText: '亿' });
                        }
                        return value;
                    }
                },
                axisLine: {
                    show: false
                },
                splitLine: {
                    lineStyle: {
                        color: '#E8E8E8',
                        type: 'dashed'
                    }
                },
                axisTick: {
                    show: false
                },
                splitNumber: 5,
                min: 0,
                max: max,
                interval: interval
            }
        ],
        series: [
            {
                name: seriesName,
                data: seriesData,
                ...getSeriseOption(tendencyTypeIndex, dataTypeIndex, echarts),
                symbol: 'image://' + AXIS_POINTER_IMG[dataTypeIndex],
                itemStyle: {
                    normal: {
                        color: COLOR_LIST[dataTypeIndex]
                    }
                }
            }
        ]
    };
}